import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/show_attachments/${container_service_id}`
    );
  },
  fetchAgroExporter({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/show_attachments/fetch_agro_exporter/${container_service_id}`
    );
  },
  create({ container_service_id, service_template_file_id, attach }) {
    let formData = new FormData();
    formData.append("container_service_attachment[container_service_attach]", attach);
    formData.append("container_service_attachment[service_template_file_id]", service_template_file_id);
    return RequesterV1.post(
      `service_provider/services/container_op/show_attachments/create/${container_service_id}`,
      formData
    );
  },
  destroy({ container_service_attachment_id }) {
    return RequesterV1.delete(
      `service_provider/services/container_op/show_attachments/destroy/${container_service_attachment_id}`,
    );
  },
  download({container_service_attachment_id}) {
    return RequesterV1.get(
      `service_provider/services/container_op/show_attachments/download/${container_service_attachment_id}`,
      { responseType: "blob" }
    );
  }
};
